import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  bottom: ', 'px;\n  left: ', 'px;\n  position: fixed;\n  z-index: ', ';\n'], ['\n  bottom: ', 'px;\n  left: ', 'px;\n  position: fixed;\n  z-index: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n'], ['\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']);

import styled from 'styled-components';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import { gridSize, math, layers } from '@atlaskit/theme';

export default styled.div(_templateObject, math.multiply(gridSize, 6), math.multiply(gridSize, 10), layers.flag);

export var SROnly = styled.h1(_templateObject2);

export var Inner = styled(TransitionGroup)(_templateObject3);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/flag/dist/esm/components/FlagGroup/styledFlagGroup.js
// module id = 480
// module chunks = 0